export const text = {
  themeName: "Fantasy Light",
};

export const colors = {
  contentSubtle: "#4D5153",
  contentLink: "#005FC8",
  contentLinkActive: "#003D81",
  borderSubtle: "#EAF0F6",
  borderDisabled: "#F7FBFF",
  linkDefaultBase: "#005FC8",
  linkDefaultHover: "#003D81",
  systemInfoLinkOnSubtle: "#005FC8",
  systemPositiveLinkOnSubtle: "#005FC8",
  systemAlertLinkOnSubtle: "#005FC8",
  systemWarningLinkOnSubtle: "#005FC8",
  systemImportantLinkOnSubtle: "#005FC8",
  systemNeutralLinkOnSubtle: "#005FC8",
  systemVerificationLinkOnSubtle: "#005FC8",
  componentButtonPrimaryBorderDisabled: "#F7FBFF",
  componentButtonSecondaryBorderDisabled: "#F7FBFF",
  componentButtonTertiaryBorderDisabled: "#F7FBFF",
  componentButtonDestructiveBorderDisabled: "#F7FBFF",
  componentButtonButtonLinkContentHover: "#005FC8",
  componentButtonButtonLinkBorderDisabled: "#F7FBFF",
  componentSelectionControlBorderDisabled: "#F7FBFF",
  componentDataInputBorderDisabled: "#F7FBFF",
  componentDataInputContentSubtle: "#4D5153",
  componentDataInputIconBase: "#4D5153",
};